export default __webpack_public_path__ + "static/media/Questions.4e7b9fb9.svg";